import { Button } from 'components/Base';
import Checkbox from 'components/Checkbox/Checkbox';
import { chargeTypes } from 'components/ProviderPlatformCharges/ProviderPlatformChargesComponent';
import { PlatformProviderChargeType } from 'components/ProviderPlatformCharges/types';
import { save } from 'components/ProviderPlatformCharges/util';
import TextInput from 'components/TextInput/TextInput';
import React, { useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { formatCurrency, unFormatCurrency, unFormatPercent } from 'utils';
import { formatPercent } from 'utils/percent';
import './fixedCharge.scss';
import DropdownInput from 'components/Dropdown/Dropdown';

type FixedChargeProps = {
  fixedChargeData: PlatformProviderChargeType | any;
  currentPolicyTypes: number[];
  updateCharge: Function;
  index: number;
  isFamilyLinked: boolean;
  checkForm: Function;
  selectedPlatformType: any;
  selectedProviderType: any;
  platformIndex: number;
  aumRangeFrom: string;
  aumRangeTo: string;
  applicationTypes: any;
  isFirmAdmin: boolean;
};

const FixedCharge = ({
  fixedChargeData,
  currentPolicyTypes,
  updateCharge,
  isFamilyLinked,
  checkForm,
  selectedPlatformType,
  selectedProviderType,
  platformIndex,
  aumRangeFrom,
  aumRangeTo,
  applicationTypes,
  isFirmAdmin
}: FixedChargeProps) => {
  const [fixedCharge, setFixedCharge] = useState(
    fixedChargeData.charge_value_type === 2
      ? formatPercent(fixedChargeData.fixed_charge * 100)
      : fixedChargeData.fixed_charge
  );

  const [applyTo, setApplyTo] = useState({
    value: fixedChargeData.apply_to ? fixedChargeData.apply_to.toString() : '1'
  });

  const [chargeValueTypeEnum, setChargeValueType] = useState(
    fixedChargeData.charge_value_type || 1
  );

  const changeChargeValueType = useDebouncedCallback(() => {
    let chargeData = fixedCharge;
    if (chargeValueTypeEnum === 2) {
      chargeData = unFormatPercent(chargeData);
      setChargeValueType(1);
    } else {
      chargeData = unFormatCurrency(chargeData);
      setChargeValueType(2);
    }
    setFixedCharge(chargeData);
  });

  return (
    <div>
      <div style={{ marginBottom: '1rem' }}>
        <span style={{ fontWeight: 'bold' }}>
          {chargeTypes[fixedChargeData.charge_type as keyof typeof chargeTypes]}{' '}
          Charge{' '}
        </span>
      </div>
      {isFirmAdmin && (
        <div className="chargeValueTypes">
          <Checkbox
            onClick={changeChargeValueType}
            label={'Percentage'}
            isChecked={chargeValueTypeEnum === 2}
            disabled={!isFirmAdmin}
          />
          <Checkbox
            onClick={changeChargeValueType}
            label={'Monetary'}
            isChecked={chargeValueTypeEnum === 1}
            disabled={!isFirmAdmin}
          />
        </div>
      )}
      <div style={{ padding: '4px' }}>
        {chargeValueTypeEnum === 1 && (
          <div style={{ marginTop: '0.3rem', display: 'flex', gap: '1rem' }}>
            {isFirmAdmin ? (
              <TextInput
                label="Fixed charge (per annum)"
                onChange={(e: any) => setFixedCharge(e)}
                value={formatCurrency(fixedCharge)}
                style={{
                  marginBottom: '0.25rem',
                  width: 'max-content',
                  minWidth: '150px'
                }}
                formatter={formatCurrency}
              />
            ) : (
              <>{formatCurrency(fixedCharge)}</>
            )}
            <DropdownInput
              label="Apply to"
              value={
                applyTo
                  ? applicationTypes.find(
                      (type: any) => type.value === applyTo.value
                    )?.name
                  : ''
              }
              disabled={!isFirmAdmin}
              onChange={(e: any) => setApplyTo(e)}
              options={applicationTypes}
              objectKey={'name'}
            />
          </div>
        )}
        {chargeValueTypeEnum === 2 && (
          <>
            {isFirmAdmin ? (
              <TextInput
                label="Fixed charge (per annum)"
                onChange={(e: any) => setFixedCharge(e)}
                value={formatPercent(fixedCharge)}
                style={{
                  marginTop: '0.3rem',
                  marginBottom: '0.25rem',
                  width: 'max-content'
                }}
                formatter={formatPercent}
              />
            ) : (
              <div style={{ marginTop: '-1rem', marginLeft: '-4px' }}>
                {formatPercent(fixedCharge)}
              </div>
            )}
          </>
        )}
      </div>
      <div style={{ display: 'none' }}>
        <Button
          id="platformProviderChargesSubmit"
          onClick={() =>
            save(
              fixedChargeData,
              Number(
                chargeValueTypeEnum === 2
                  ? unFormatPercent(fixedCharge) / 100
                  : unFormatCurrency(fixedCharge)
              ),
              currentPolicyTypes,
              aumRangeFrom,
              aumRangeTo,
              chargeValueTypeEnum,
              isFamilyLinked,
              selectedPlatformType,
              selectedProviderType,
              'fixed_charge',
              platformIndex,
              updateCharge,
              checkForm,
              applyTo
            )
          }
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default FixedCharge;
